module.exports = __webpack_public_path__ + "static/media/riskpic1@3x.0aa54e52.png";